export enum EnOrdemProcesso {
    SistemaEAppEObedeceAgrupamento = 1,
    SomenteAppNaoObedeceAgrupamento = 2,
    SomenteSistemaEObedeceAgrupamento = 3,
    EmLugarNenhum = 99
}
